(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4914],{

/***/ 95726:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/WebAdmin",
      function () {
        return __webpack_require__(952);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _design_WebAdmin_layouts_AdminLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14541);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);



var AdminIndex = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: "Admin dashboard"
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AdminIndex);
// ----------------------------------------------------------------------
AdminIndex.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_design_WebAdmin_layouts_AdminLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        pageTitle: "Dashboard",
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2495,4541,9774,2888,179], function() { return __webpack_exec__(95726); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);